export default "__VITE_ASSET__ff6f7635__"